/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const visitExtractionAllergyReviews = sqliteTable('visit_extraction_allergy_reviews', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  visit_id: text('visit_id'),
  extraction_id: text('extraction_id'),
  source_recording_id: text('source_recording_id'),
  raw_value: text('raw_value'),
  normalized_value: text('normalized_value'),
  status: text('status'),
  resolution_action: text('resolution_action'),
  resolved_allergy_id: text('resolved_allergy_id'),
  confirmed_by: text('confirmed_by'),
  confirmed_at: text('confirmed_at'),
  dismissed_by: text('dismissed_by'),
  dismissed_at: text('dismissed_at'),
  created_by: text('created_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
